const baseUrl = (() => {
  return process.env.REACT_APP_BASE_API_URL;
})();

export default baseUrl;
